import * as _ from 'lodash';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dataFilter',
})
export class DataFilterPipe implements PipeTransform {

    transform(array: any[], query: string): any {
        if (query) {
            return _.filter(array, row => (row.email) ? (row.email.toLowerCase().indexOf(query.toLowerCase()) > -1) : false);
        }
        return array;
    }
}



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/theme/pipes/dataFilter/data-filter.pipe.ts